<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xl3 lg6 xs6>
                            <v-text-field
                              v-model="filters.busCls"
                              :label="labels.busCls"
                              :error-messages="errors.collect('busCls')"
                              data-vv-name="busCls"
                              :data-vv-as="labels.busCls"
                              v-validate="'name|max:4'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xl3 lg6 xs6>
                            <v-text-field
                              v-model="filters.busClsDesc"
                              :label="labels.busClsDesc"
                              :error-messages="errors.collect('busClsDesc')"
                              data-vv-name="busClsDesc"
                              :data-vv-as="labels.busClsDesc"
                              v-validate="'max:40'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xl3 lg6 xs6>
                            <v-autocomplete
                              :items="busClsGrpList"
                              v-model="filters.busClsGrp"
                              :label="labels.busClsGrp"
                              item-text="label"
                              item-value="value"
                              data-vv-name="busClsGrp"
                              :data-vv-as="labels.busClsGrp"
                              :error-messages="errors.collect('busClsGrp')"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xl3 lg6 xs6>
                            <v-autocomplete
                              :items="glanCodeList"
                              v-model="filters.glAc"
                              :label="labels.glAc"
                              item-text="label"
                              item-value="value"
                              data-vv-name="glAc"
                              :data-vv-as="labels.glAc"
                              :error-messages="errors.collect('glAc')"
                              clearable
                            ></v-autocomplete>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="doNewBusCls()"> New Business Class<v-icon right>mdi-plus</v-icon> </v-btn>
          <download-csv :data="busClsList" name="BusinessClassList.csv">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark small color="primary" v-on="on">
                  <v-icon dark>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Download CSV</span>
            </v-tooltip>
          </download-csv>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table
              :headers="headers"
              :items="items"
              v-bind:options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row"
                ><tr>
                  <td>{{ row.item.busCls }}</td>
                  <td class="text-xs-left">{{ row.item.busClsDesc }}</td>
                  <td class="text-xs-left">{{ convertAppId(row.item.busClsAppId) }}</td>
                  <td class="table-action-header">
                    <table-action
                      :rowData="row"
                      query
                      @query="doBusClsQuery(row.item.busCls)"
                      review
                      @review="doBusClsReview(row.item.busCls)"
                      remove
                      @remove="doRemoveValidate"
                    ></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <confirm v-model="promptRemove" @ok="doDelete">
              <p>Are you sure you want to delete the selected Business Class?</p>
              <div class="title">{{ selectedBusCls.busCls }} - {{ selectedBusCls.busClsDesc }}</div>
            </confirm>
          </v-card>
        </v-flex>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { appIDDesc } from '@/const/underwriting'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      headers: [
        { text: 'Class', align: 'left', value: 'busCls' },
        { text: 'Description', value: 'busClsDesc' },
        { text: 'App ID', value: 'busClsAppId' },
        TableConst.tableActionHeader
      ],
      labels: {
        busCls: 'Business Class Code',
        busClsDesc: 'Business Class Description',
        busClsGrp: 'Business Class Group',
        glAc: 'GL Analysis Code'
      },
      filters: {
        busCls: undefined,
        busClsDesc: undefined,
        busClsGrp: undefined,
        glAc: undefined
      },
      title: 'Business Class',
      sideFunction: [
        {
          text: 'Permit Benefit',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pmtBenefitPerBusClsList' }
        },
        /* OS-135
         {
          text: 'Permit Clause',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'inProgress' }
        }, */
        {
          text: 'Permit Cover Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'busClsCvr' }
        },
        /* OS-135
         {
          text: 'Permit Statistic Type',
          icon: 'mdi-launch',
          iconColor: 'primary',
          params: { name: 'inProgress' }
        }, */
        {
          text: 'Permit Standard Risk Text',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pmtStdRiskTxtPerBusCls' }
        },
        {
          text: 'Permit Tariff',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'pmtTariffPerBusCls' }
        },
        {
          text: 'Permit UOM',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'busClsUom' }
        },
        {
          text: 'Business Class Group',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'busClsGroup' }
        }
      ],
      totalItems: 0,
      busClsGrpList: [],
      glanCodeList: [],
      busClsList: [],
      removeBusCls: null,
      loading: false,
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      },
      selectedBusCls: {
        busCls: null,
        busClsDesc: null
      }
    }
  },
  created() {},
  computed: {
    busClsMenu() {
      return this.$store.state.busClsParam.menu
    }
  },
  methods: {
    convertAppId(appId) {
      return appIDDesc[appId]
    },
    async doInit(options) {
      this.resetMessages()
      await this.getAll()
      const apiURI = this.busClsMenu.getBusClsList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((busCls) => {
                const convertList = {
                  busCls: busCls.busCls,
                  busClsDesc: busCls.busClsDesc,
                  busClsAppId: busCls.busClsAppID
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    async getAll() {
      const apiURI = this.busClsMenu.getBusClsAllList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.busClsList = []
        if (data) {
          data.map((busCls) => {
            const convertList = {
              busCls: busCls.busCls,
              busClsDesc: busCls.busClsDesc,
              busClsAppId: busCls.busClsAppID
            }
            this.busClsList.push(convertList)
          })
        }
      }
    },
    fetchFilterList() {
      const getState = this.$store.state.busClsParam
      this.busClsGrpList = getState.busClsGrpList
      this.glanCodeList = getState.glanCodeList
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.busCls = null
      this.filters.busClsDesc = null
      this.filters.busClsGrp = null
      this.filters.glAc = null
      this.pagination.page = 1
      this.doInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pagination.page = 1
          this.doInit(false)
        }
      })
    },
    doBusClsReview(busCls) {
      this.$router.push({ name: 'busClsReview', params: { busCls: busCls } })
    },
    doBusClsQuery(busCls) {
      this.$router.push({ name: 'busClsQuery', params: { busCls: busCls, delete: false } })
    },
    doNewBusCls() {
      this.$router.push({ name: 'busClsReview', params: { busCls: 'new' } })
    },
    async doRemoveValidate(data) {
      const apiURI = this.busClsMenu.deleteValidation
      if (apiURI) {
        const expand = data.item
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            this.selectedBusCls.busCls = data.item.busCls
            this.selectedBusCls.busClsDesc = data.item.busClsDesc
            this.promptRemove = true
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    async doDelete() {
      const apiURI = this.busClsMenu.deleteBusCls
      if (apiURI) {
        const expand = this.selectedBusCls
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.doInit(false)
    }
  },
  mounted() {
    this.fetchFilterList()
    this.doInit(true)
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>
